import { GetterTree } from 'vuex'
import { Application, ApplicationsState, applicationTypeCode } from '@/store/applications/types'
import { RootState } from '@/store/types'

const applicationGetters : GetterTree<ApplicationsState, RootState> = {
  /**
   * 申請IDを元に申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {Application|null} 申請情報
   */
  findApplicationById: (state, getters) => (applicationId: string): Application|null => {
    const application = state.applications.find(
      (app: Application) => app.id === applicationId,
    ) || null

    if (!application) {
      return null
    }

    switch (application.type) {
      case 'vacation':
        return getters.findVacationApplicationById(application.id)
      case 'booth':
        return getters.findBoothApplicationById(application.id)
      case 'workOvertime':
        return getters.findWorkOvertimeApplicationById(application.id)
      case 'spir':
        return getters.findSpirApplicationById(application.id)
      case 'inquiry':
        return getters.findEvaluationInquiryApplicationById(application.id)
      default:
        return null
    }
  },
}

export default applicationGetters
